function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 188 97",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-text",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 98 28.5 L 82 28.5 C 79.79 28.5 78 30.29 78 32.5 L 78 64.5 C 78 66.71 79.79 68.5 82 68.5 L 106 68.5 C 108.21 68.5 110 66.71 110 64.5 L 110 40.5 Z",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "98 28.5 98 40.5 110 40.5",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 50.5,
    x2: 86,
    y2: 50.5,
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 58.5,
    x2: 86,
    y2: 58.5,
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90 42.5 88 42.5 86 42.5",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.337e997ca697533bd554b5b8a6671c88.svg";
export { ForwardRef as ReactComponent };